import { useQuery as useQueryParams } from '@kiper/hooks';
import { PersonalizedInviteProvider } from '../../../../store/PersonalizedInvite';
import PersonalizedInvite from '../PersonalizedInvite';
import {
  adaptInviteGuestToPersonalizedInvite,
  isInviteExpired,
  isInviteValid,
} from '../adapters/inviteGuestAdapter';
import LoadingPage from '../../../../components/LoadingPage';
import { useFetchInviteGuest } from '../../InviteGuest/hooks';
import InviteError, {
  InviteErrorTypes,
} from '../../../../components/InviteError';

const PersonalizedInviteAdapterContainer = () => {
  const querystring = useQueryParams();
  const guestHash = querystring?.get('q')?.replace(/ /g, '+') || '';

  const { data: queryData, loading, error } = useFetchInviteGuest({
    guestHash,
  });
  const inviteGuestData = queryData?.getInviteGuest;

  if (loading || !guestHash) {
    return <LoadingPage />;
  }

  if (error || !isInviteValid(inviteGuestData)) {
    return <InviteError type={InviteErrorTypes.INVALID} />;
  }

  if (isInviteExpired(inviteGuestData)) {
    return <InviteError type={InviteErrorTypes.EXPIRED} />;
  }

  const adaptedData = adaptInviteGuestToPersonalizedInvite(inviteGuestData);

  return (
    <PersonalizedInviteProvider
      inviteData={adaptedData}
      loading={loading}
      error={error}
    >
      <PersonalizedInvite />
    </PersonalizedInviteProvider>
  );
};

export default PersonalizedInviteAdapterContainer;
